import React, { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteProduct, fetchProducts } from "../../../redux/productSlice.js";
import WarningShipmentModalComponent from "../../../components/Modals/WarningShipmentModalComponent.js";
import SuccessModal from "../../../components/Modals/SuccessfulModal.js";
import deleteIcon from "../../../assets/images/trash.svg";
import editIcon from "../../../assets/images/editIcon.svg";
import "./ProductCard.css";

const ProductCard = ({ product, initialPageSize, totalRecords }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);

  const pageIndex = useMemo(() => 1, []); // Simplified since pageIndex isn't dynamically changed here
  const totalPages = useMemo(
    () => Math.ceil(totalRecords / initialPageSize),
    [totalRecords, initialPageSize]
  );

  // Navigate to view product details
  const handleViewProduct = () => {
    navigate(`/view-product/${product?._id}`, {
      state: { actionType: "view", productId: product?._id },
    });
  };

  // Open delete modal
  const handleDeleteProductBtnClick = () => {
    setIsDeleteModalOpen(true);
  };

  // Handle deletion of product
  const handleDelete = () => {
    const id = product._id;
    dispatch(deleteProduct({ productId: id }))
      .then(() => {
        setIsDeleted(true);
        dispatch(fetchProducts({ searchText: "", pageSize: 9, pageNumber: 1 }));
      })
      .catch((error) => {
        console.error("Error deleting product:", error);
      });
  };

  // Close delete modal
  const onDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
  };

  // Navigate to edit product page
  const handleEditProductBtnClick = () => {
    navigate(`/edit-products/${product?._id}`, {
      state: { actionType: "edit", productId: product?._id },
    });
  };
  return (
    <>
      <div className="product-wrapper">
        <div className="card-container">
          <div className="product-card">
            <div
              className="product-header"
              onClick={handleViewProduct}
              as="button"
            >
              <img
                src={product?.productCoverImage}
                className="card-cover-img"
                alt="cover image"
              />
            </div>

            <div className="product-content">
              <hr className="card-line" />
              <p className="company-name">{product?.productName}</p>
              <p className="product-description">
                {product?.productDescription}
              </p>
            </div>
            <div className="uom-wrapper">
              <div className="card-footer">
                <div>
                  <span className="uom">Quantity </span>
                  <span className="uom">{product?.quantity}</span>
                </div>
                <div>
                  <span className="uom">Price </span>
                  <span className="uom">{product?.amount}</span>
                </div>
                <div className="clays-sm">
                  <button
                    className="icon-clay"
                    onClick={handleDeleteProductBtnClick}
                  >
                    <span className="inner-clay color-black">
                      <img src={deleteIcon} alt="Delete" />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isDeleteModalOpen && (
        <WarningShipmentModalComponent
          isOpen={isDeleteModalOpen}
          onClose={onDeleteModalClose}
          handleDelete={handleDelete}
        />
      )}

      {isDeleted && (
        <SuccessModal
          isOpen={isDeleted}
          msg={"Product Deleted Successfully"}
          navigatePage={"/products"}
        />
      )}
    </>
  );
};

export default ProductCard;
